import { useState } from "react";
import { FALLBACK_IMG } from "@/store/constants";
import type { Product } from "@/store/types";
import { cn } from "@/lib/utils";

interface ProductImageProps {
  product: Product;
  className?: string;
  lazy?: boolean;
}

/**
 * Product image that falls back to the AGD logo when the product has no image
 * or its image fails to load. The fallback is shown "contained" (not cropped).
 */
export default function ProductImage({ product, className, lazy }: ProductImageProps) {
  const hasImage = !!product.IMAGE_URL;
  const [failed, setFailed] = useState(false);
  const showFallback = !hasImage || failed;

  return (
    <img
      className={cn(className, showFallback && "agd:object-contain agd:bg-white")}
      src={showFallback ? FALLBACK_IMG : product.IMAGE_URL}
      alt={product.Title ?? ""}
      loading={lazy ? "lazy" : undefined}
      onError={() => {
        if (!showFallback) setFailed(true);
      }}
    />
  );
}
